import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NgClass, NgStyle } from '@angular/common';

@Component({
  selector: 'ui-loader',
  imports: [NgClass, NgStyle],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { '[attr.data-cy]': 'dataCy() || null' },
})
export class LoaderComponent {
  dataCy = input<string>('');
  size = input<'big' | 'small'>('small');
  global = input<boolean>(false);
  single = input<boolean>(false);
  class = input<string>('');
}
